<template>
  <div>
    <!-- <el-slider
      v-show="showchart"
      class="hidden-md-and-down"
      :max="24"
      :show-tooltip="false"
      v-model="tablewidth"
    ></el-slider> -->

    <el-row>
      
      <el-col :lg="tablewidth">
        <div style="overflow-x: auto">
          <vuetable></vuetable>
        </div>
      </el-col>

      <el-col
        v-if="showchart"
        :lg="24 - tablewidth"

      >
      <dragbox @reset="tablewidth=16" @positioning="tablewidth=23.8" @close="$store.commit('setifchart')" 
      v-bind:style="
          $store.state.ifremotechart
            ? { background: 'rgba(232, 240, 194,1)' }
            : {background: 'rgba(111, 240, 194,1)'}
        "
        >
        
        <template v-slot:content>
  
        <!-- <div style="height:2rem"></div> -->
        <thechart v-if="chartmodel === 'group'"></thechart>
        <charttime v-else-if="chartmodel === 'time'"></charttime>

        <div v-if="$store.state.ifremotechart">
          <el-button
            v-if="ifreduceiconshow"
            type="text"
            style="font-size: 1.5rem"
            @click="reducechartdataxy"
            >&#171;</el-button
          >
          <el-button
            v-if="!chartdatanomore"
            type="text"
            style="font-size: 1.5rem"
            @click="remotechartdatamore"
            >&#187;</el-button
          >
        </div>
        </template>
      </dragbox>

        <!-- <el-button type="danger" size="mini" icon="el-icon-download" @click="chartdownload">下载</el-button> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>

import "element-ui/lib/theme-chalk/display.css";
import dragbox from '@/components/utility/dragbox/dragbox.vue'
import vuetable from "./table/table";
import thechart from "./chart/thechart";
// import chartgroup from "./chartgroup";
import charttime from "./chart/charttime";
import {
  chartdataxy,
  chartdatagroup,
  chartdatatimes,
  renewitems,
} from "@/components/utility/indexdb";
export default {
  components: {dragbox, vuetable, thechart, charttime },
  mounted() {
    if (this.showchart) {
      this.tablewidth = 16;
    }
  },
  data() {
    return {
      tablewidth: 24,
      yvalues: [],
      tempexcelfields: [],
  }},

  computed: {
    // tablewidth(){
    //   return this.$store.state.clct && this.$store.state.yvalues?16:24
    // },
    ifreduceiconshow() {
      return (
        this.$store.state.chartdataxy.length >
        this.$store.state.datainformation.perpage
      );
    },
    chartdatanomore() {
      return this.$store.state.chartdatanomore;
    },
    showchart() {
      return this.$store.getters.showchart;
    },
    clct() {
      return this.$store.state.clct;
    },
    dbprocessing() {
      return this.$store.state.dbprocessing;
    },
    chartmodel() {
      return this.$store.state.chartmodel;
    },
    // charttype:{
    //   get:function(){return this.$store.state.charttype},
    //   set:function(val){this.$store.commit("setcharttype",val)}
    // }
  },

  watch: {
    showchart(newval) {
      if (newval) {
        this.tablewidth = 16;
        //初始化图表数据
        // chartdataxy(this.$store.state.xfield, this.$store.state.yvalues).then(
        //   doc => {
        //     chartdatagroup(
        //       this.$store.state.xfield,
        //       this.$store.state.yvalues,
        //       doc
        //     );
        //   }
        // );
      } else {
        this.tablewidth = 24;
      }
    },
    clct(newval, oldval) {
      //如果不存在numberfields那么不展示chart
      if (!this.showchart) {
        this.tablewidth = 24;
      } else {
        this.tablewidth = 16;
      }
    },
  },

  methods: {
    // positioned(positioninfo){
    //   // console.log(positioninfo)
    //   if(positioninfo.position=="absolute" && positioninfo.type=="mousedown"){
    //     // console.log("is absolute，to change to 23.5")
    //     // this.thestyle.position="absolute"
    //     // this.$store.commit("setifchart",false)
    //     this.tablewidth = 23.5;
    //   }
    //   if(positioninfo.position=="relative" && positioninfo.theposition=="reset" ){
    //     // console.log("adfadf")
    //     this.tablewidth = 16;
    //   }
    //   // if(positioninfo.position=="absolute" && positioninfo.theposition=="right"){
    //   //   console.log("is absolute and right to change to relative and 16")
    //   //   this.tablewidth=16
    //   //   // this.thestyle={position: "relative",width: "100%",height: "100%",top: 0,left: 0}
    //   // }
    // },
    reducechartdataxy() {
      this.$store.commit("setchartdatanomore", false);
      let perpage = this.$store.state.datainformation.perpage;
      this.$store.state.chartdataxy.splice(-perpage);
      if (this.$store.state.chartmodel === "group") {
        chartdatagroup(
          this.$store.state.xfield,
          this.$store.state.yvalues,
          this.$store.state.chartdataxy
        );
      }
      if (this.$store.state.chartmodel === "time") {
        chartdatatimes(
          this.$store.state.xfield,
          this.$store.state.yvalues,
          this.$store.state.chartdataxy
        );
      }

      // this.$store.commit("setchartdataxy", this.$store.state.chartdataxy.splice(-10))
    },
    remotechartdatamore() {
      this.$axios.fetchremotechartdata(
        this.$store.state.chartmodel,
        this.$store.state.chartdataxy.length
      );
    },
    chartdownload() {
      let canvas = this.$el.querySelector("canvas").toDataURL("image/png");
      let link = document.createElement("a");
      link.download = "数据图";
      link.href = canvas;
      link.click();
    },
  },
};
</script>

<style>
.el-slider__runway {
  width: 100%;
  height: 3px;
  margin: 5px 0;
  background-color: #e4e7ed;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}
.el-slider__bar {
  height: 3px;
  background-color: #409eff;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  position: absolute;
}
</style>




// WEBPACK FOOTER //
// src/components/presentation/layout.vue